import { Download, X, Share } from 'lucide-react';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

export default function InstallPrompt() {
  const { showInstallBanner, isIOS, triggerInstall, dismissPrompt } = useInstallPrompt();

  if (!showInstallBanner) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9998] bg-gradient-to-r from-phoenix-500 to-orange-600
                 text-white shadow-2xl border-t-4 border-gold-400 animate-slide-up"
      role="banner"
    >
      <div className="max-w-7xl mx-auto px-4 py-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between flex-wrap gap-2">
          {/* Message */}
          <div className="flex items-center gap-3 flex-1">
            <Download className="w-6 h-6 shrink-0" />
            <div>
              <p className="font-semibold text-lg font-display">
                {isIOS ? 'Add to Home Screen' : 'Install Life Re:Scripted'}
              </p>
              <p className="text-sm text-white/90">
                {isIOS ? (
                  <>
                    Tap <Share className="inline w-4 h-4 -mt-0.5" /> then &quot;Add to Home Screen&quot; for the full app experience.
                  </>
                ) : (
                  'Get the full app experience — quick access from your desktop or home screen.'
                )}
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2">
            {!isIOS && (
              <button
                onClick={triggerInstall}
                className="bg-white text-phoenix-600 px-5 py-2 rounded-lg font-semibold
                         hover:bg-gold-50 hover:-translate-y-0.5 transition-all duration-200 shadow-md
                         flex items-center gap-2"
              >
                <Download className="w-4 h-4" />
                Install
              </button>
            )}
            <button
              onClick={dismissPrompt}
              className="p-2 hover:bg-white/10 rounded-lg transition-colors duration-200"
              aria-label="Dismiss install prompt"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-up {
          animation: slide-up 0.4s ease-out;
        }
      `}</style>
    </div>
  );
}
